import { render, staticRenderFns } from "./CartSummary.vue?vue&type=template&id=70c686b6&scoped=true"
import script from "./CartSummary.vue?vue&type=script&lang=js"
export * from "./CartSummary.vue?vue&type=script&lang=js"
import style0 from "./CartSummary.vue?vue&type=style&index=0&id=70c686b6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c686b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70c686b6')) {
      api.createRecord('70c686b6', component.options)
    } else {
      api.reload('70c686b6', component.options)
    }
    module.hot.accept("./CartSummary.vue?vue&type=template&id=70c686b6&scoped=true", function () {
      api.rerender('70c686b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/CartSummary.vue"
export default component.exports